import React, { useEffect, useState, useRef } from 'react'
import style from './config.module.css'
import { useDispatch, useSelector } from 'react-redux';
import { 
    Col,
    Form, 
    Row,
    Spinner, 
    Modal,
    Button
} from 'react-bootstrap';
import { Dialog } from '../../Components/UI/Dialog'
import { 
    Folder2Open,
} from 'react-bootstrap-icons';
import { RetargetingConfigAction } from '../../Redux/Actions/RetargetingConfigAction';
import { useFormik } from 'formik';


const RetargetingConfig = () => {
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [image, setImage] = useState<any>({})
    const [fileContent, setFileContent] = useState<string>()
    const [isUpload,setIsUpload] = useState(false)
    const [successLinesCounter, setSuccessLinesCounter] = useState(0);
    const [failedLinesCounter, setFailedLinesCounter] = useState(0);

    const [isFileUpload, setIsFileUpload] = useState({ file: true, single: false })
    const [isLoading, setLoading] = useState(false);
    const [showError, setShowError] = useState(false);
    const retargetingConfigState = useSelector((state: any) => state.RetargetingConfig)
    const dispatch = useDispatch()

    useEffect(() => {
        setLoading(retargetingConfigState?.loading)
    }, [retargetingConfigState?.loading])


     const onChangeFileHandler = (e: any) => {
         setShowError(false);
         setImage({});
         setShowError(false);
         setFileContent('');
    
         const file = e.target.files[0];
         if (file.name.split('.').pop() === 'csv') {
             setImage(file);
             const reader = new FileReader();
             reader.onload = (event) => {
                 const content = event.target?.result as string;
                 setFileContent(content);
             };
             reader.readAsText(file);
         } else {
             setShowError(true);
         }
    }
    

    const handleChangeFileFormate = (e: any, type: string) => {
        formikData.setFieldValue('single', '')
        formikData.setFieldValue('csvFile', {})
        setImage({})
        if (type === 'file') setIsFileUpload({ file: true, single: false })
        else if (type === 'single') setIsFileUpload({ file: false, single: true })
    }

    const formikData = useFormik<any>({
        initialValues: {
            single: '',
            continent: 'ALL',
            user_id_type: '',
            segment: ''
        },
        onSubmit: (value, { resetForm }) => {
            setFailedLinesCounter(0);
            setSuccessLinesCounter(0);
            
            if (value.segment == '') {
                return;
            }

            const formData = new FormData();

            if (isFileUpload.file) {
                // File upload mode
                const content = fileContent as string;
                const lines = content.split(/\r\n|\r|\n/);
                let regex = new RegExp('');
                if(value.user_id_type==='IDFA'){
                    regex = /^[{]?[0-9A-F]{8}-([0-9A-F]{4}-){3}[0-9A-F]{12}[}]?$/;
                } else if (value.user_id_type==='AD_ID'){
                    regex = /^[{]?[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}[}]?$/;
                } else if (value.user_id_type==='IP_ADDRESS'){
                    regex = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\n)*(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
                }else if(value.user_id_type==='BEESWAX'){
                    regex = /[^\s\\]{22}$/;
                }
                else if (value.user_id_type==='IDFA_SHA' || value.user_id_type==='AD_ID_SHA'){
                    regex = /^[a-f0-9]{40}$/; 
                }
                
                for (var i in lines) {
                    if (regex.test(lines[i])) {
                        setSuccessLinesCounter(prev => prev + 1);
                    } else if (lines[i]!== '') {
                        setFailedLinesCounter(prev => prev + 1);
                    }
                }
                image.name && formData.append('csvfile', image)
            } else {
                // Single value mode - just append the single value
                formData.append('single', value.single);
                // Set counter to 1 for single successful upload
                setSuccessLinesCounter(1);
            }

            // Common form data for both modes
            formData.append('continent', value.continent);
            formData.append('user_id_type', value.user_id_type);
            formData.append('segment', value.segment);

            // Dispatch in both cases
            dispatch(RetargetingConfigAction(formData));
            setIsUpload(true);
            
            // Reset everything
            resetForm();
            setImage({});
            setFileContent('');
            setShowError(false);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        }
    })

    return (<>
        <Dialog visible={isUpload}>
            <Modal.Header closeButton style={{ border: "none" }} onHide={() => setIsUpload(false)} />

            <Modal.Body className={style.modal_body}>
            <h3>Uploaded</h3>
            <p>{`${successLinesCounter} values were successfully uploaded. ${failedLinesCounter} failed - type mismatch error`}</p>
            </Modal.Body>

            <Modal.Footer className={style.modal_footer}>
            <Button size="lg" onClick={() => setIsUpload(false)}  >Close</Button>
            </Modal.Footer>
        </Dialog>
        <div>
            <Row>
                <Col lg="6" md="8" className="mx-auto mb-5">
                    <h3 style={{ color: "#000", textAlign: 'center' }}>
                        Targeting Config
                    </h3>
                </Col>
            </Row>
            <div className={style.main_from_div}>
                <div className={style.retargeting_screen}>
                    <div className={style.upload_format}>
                        <button className={style.upload_button}>Upload Format</button>
                        <div className={style.retargeting_screen_full}>
                            <div key={`inline-radio`} className="mb-3">
                                <Form>
                                    {['radio'].map((type: string) => (
                                        <div key={`inline-${type}`} className={style.main_checkbox_box}>
                                            <div className={style.file_check}>
                                                <Form.Check
                                                    inline
                                                    defaultChecked={isFileUpload?.file}
                                                    name="file"
                                                    onChange={(e: any) => handleChangeFileFormate(e, 'file')}
                                                    type={"radio"}
                                                    id={`inline-${type}-1`}
                                                />
                                                <Form.Label className={style.lable_name}>File /</Form.Label>
                                            </div>
                                            <div className={style.singal_check}>
                                                <Form.Check
                                                    inline
                                                    defaultChecked={isFileUpload?.single}
                                                    onChange={(e: any) => handleChangeFileFormate(e, 'single')}
                                                    name="file"
                                                    type={"radio"}
                                                    id={`inline-${type}-2`}
                                                />
                                                <Form.Label className={style.lable_name}>Single</Form.Label>
                                            </div>
                                        </div>
                                    ))}
                                </Form>
                                {isFileUpload?.file && <div className='upload-file-section'>
                                    <Form.Label className={style.lable_name}>File</Form.Label>
                                    <div className={style.choose_wrap} style={{ color: 'black' }}>
                                        <div className="choose-wrap-left">
                                            <Form.Group controlId="formFile" className={style.choose_wrap_inner}>
                                                <Form.Label className={style.form_label}>Choose File</Form.Label>
                                                <div className={style.icon_wrap}>
                                                    <Folder2Open />
                                                </div>
                                                <Form.Control
                                                    ref={fileInputRef}
                                                    type="file"
                                                    name='csvFile'
                                                    onChange={onChangeFileHandler}
                                                />
                                            </Form.Group>
                                        </div>

                                    </div>
                                    <div className={style.upload_file_name}>
                                        {image?.name && <h5>{image?.name}</h5>}
                                        {showError &&
                                            <div className='show-error'>
                                                <p>File type should be .csv format</p>
                                            </div>
                                        }
                                    </div>
                                </div>}
                                {isFileUpload?.single && <div className={style.sinagl_input}>
                                    <Form.Label className={style.lable_name}>Single</Form.Label>
                                    <Form.Control
                                        name='single'
                                        className={style.input_box}
                                        size="lg"
                                        onChange={formikData.handleChange}
                                        onBlur={formikData.handleBlur}
                                        value={formikData.values.single}
                                    />
                                </div>}
                            </div>
                        </div>
                    </div>
                    <div className={style.user_type}>
                        <Form.Group>
                            <Form.Select
                                name='user_id_type'
                                onChange={formikData.handleChange}
                                onBlur={formikData.handleBlur}
                                value={formikData.values.user_id_type}
                            >
                                <option value={''}>--User id type--</option>
                                {['IDFA', 'AD_ID', 'IP_ADDRESS', 'BEESWAX', 'IDFA_SHA', 'IDFA_MD5', 'AD_ID_SHA', 'AD_ID_MD5']
                                    .map((item: string) => (
                                        <option key={item} value={item}>{item}</option>
                                    ))}
                            </Form.Select>
                        </Form.Group>
                    </div>
                    <div className={style.continent_select}>
                        <Form.Group>
                            <Form.Select
                                name='continent'
                                onChange={formikData.handleChange}
                                onBlur={formikData.handleBlur}
                            >
                                <option value={''}>--Continent--</option>
                                {['APAC', 'EMEA', 'NAM', 'ALL'].map((item: string) => (
                                    <option selected={formikData.values.continent === item} key={item} value={item}>{item}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </div>
                    <div className='segment'>
                        <Form.Label className={style.lable_name_box}>Segment</Form.Label>
                        <Form.Control
                            onChange={formikData.handleChange}
                            onBlur={formikData.handleBlur}
                            name='segment'
                            className={style.input_box}
                            size="lg"
                            value={formikData.values.segment}
                        />
                    </div>
                </div>
                <div className={style.main_upload_button}>
                    <button
                        onClick={() => {
                            formikData.handleSubmit();
                            // Don't call resetForm here since it's already called in onSubmit
                        }}
                    >
                        {isLoading ? (
                            <span style={{ marginRight: 10 }}>
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                            </span>
                        ) : null}
                        {isLoading ? 'Uploading...' : 'upload'}
                    </button>
                </div>
            </div>
        </div >
        </>)
};

export default RetargetingConfig;
